import fetchData from '@/lib/fetchData';
import processJSON from '@/lib/processJSON';

const ROOT_API = process.env.VUE_APP_ROOT_API;
const GET_ACT_LPO_LIST = ROOT_API + 'act_data/get_act_lpo_list.php';
const CREATE_LEASE = ROOT_API + 'create_lease.php';

export default {
	state: {},
	mutations: {},

	actions: {

		async addToGroup(context, lpoList) {
			const { rootState, dispatch } = context;

			const currentLpo = rootState.lpoData.currentLpo;

			const updateSection = [];
			for (const lpo of lpoList) {
				const temp = {
					'tab_name': 'data_lpo',
					'f_v': {
						'id': lpo.lpo_id,
						'lease_id': currentLpo.lease_id
					}
				};
				updateSection.push(temp);
			}

			const deleteSection = [];

			const leaseList = [];

			/* формируем массив со всеми арендами, которые есть в добавляемых обследованиях */
			for (const lpo of lpoList) {
				if (!lpo.lease_id) {
					continue;
				}

				if (lpo.lease_id === currentLpo.lease_id) {
					continue;
				}

				if (!leaseList.includes(lpo.lease_id)) {
					leaseList.push(lpo.lease_id);
				}
			}

			for (const lease of leaseList) {
				/* получить все обследования с данной арендой */
				const leaseLpoList = await dispatch('_getLeaseLpoList', lease);

				const lpoListWithLease = lpoList.filter(lpo => lpo.lease_id === lease);

				/* если пользователь добавляет все обследования с одной арендой, значит аренду нужно удалить */
				if (leaseLpoList.length === lpoListWithLease.length) {
					const temp = {
						'tab_name': 'data_lpo_lease',
						'id': lease
					};
					deleteSection.push(temp);
				}
			}

			const json_obj = [
				{
					'u': updateSection,
				},
				{
					'd': deleteSection
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;
			return processJSON(json_str);
		},

		_getLeaseLpoList(context, lease_id) {
			const form = new FormData();
			form.append('lease_id', lease_id);

			return fetchData(GET_ACT_LPO_LIST, form).catch(err => {
				throw err;
			});
		},

		excludeFromGroup(context, lpoList) {
			const { dispatch } = context;

			const updateSection = [];
			for (const lpo of lpoList) {
				const temp = {
					'tab_name': 'data_lpo',
					'f_v': {
						'id': lpo.lpo_id,
						'lease_id': null,
					}
				};
				updateSection.push(temp);
			}

			const json_obj = [
				{
					'u': updateSection,
				},
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				for (const lpo of lpoList) {
					dispatch('_createLeaseForExcluded', lpo);
				}
			})
		},

		_createLeaseForExcluded(context, lpo) {
			const lpoListStr = "'" + lpo.lpo_id + "'";

      const form = new FormData();
      form.append('lpo_list_str', lpoListStr);

      return fetchData(CREATE_LEASE, form).catch(err => {
				throw err;
			});
		},

		removeLpoFromList(context, lpo) {
			const { rootState } = context;

			const actLpoList = rootState.lpoData.actLpoList;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo',
							'id': lpo.lpo_id
						}
					]
				}
			];

			if (actLpoList.length === 1) {

				if (lpo.lease_id) {
					const tempLease = {
						'tab_name': 'data_lpo_lease',
						'id': lpo.lease_id
					};
					json_obj[0].d.push(tempLease);
				}
			}

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;
			return processJSON(json_str);
		}

	}
};